/** @prettier */

/* eslint-disable indent-legacy */
import { Record } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

import Currency from '../../../containers/Currency';
import Selection from '../../../containers/Multiples/ActiveSelection';

import PromoIconWhite from '../../../../images/betslip/UI_promos_white.svg';

import style from './ActiveMultiple.module.scss';

const TextDivider = () => <span className={style.textDivider}>&nbsp;|&nbsp;</span>;

const ActiveMultiple = ({ multiple, index, showDetails, onShowDetails }) => {
  const {
    selections,
    totalStake,
    potentialReturn,
    name: permutationName,
    combinations,
    useBonus,
  } = multiple.toJS();

  const legsClass = [style.legs, showDetails ? style['legs--showDetails'] : ''].join(' ');

  return (
    <div className={style.main}>
      <div className={style.header}>
        <div className={style.name}>
          <span className={style.permutationName}>
            {permutationName}
            {useBonus && <PromoIconWhite />}
          </span>
          <span role="button" onClick={() => onShowDetails(index)} className={style.showToggle}>
            {showDetails ? 'Show less' : 'Show details'}
          </span>
        </div>
        <div className={style.description}>
          <span>{`${combinations} ${combinations > 1 ? 'Bets' : 'Bet'} `}</span>
          <TextDivider />
          <Currency value={totalStake} />
          {' Total Stake'}
          <TextDivider />
          <Currency value={potentialReturn} />
          {' Return'}
        </div>
      </div>
      <div className={legsClass}>
        {selections.map((selection, i) => {
          if (showDetails) {
            return (
              <Selection
                {...selection}
                key={selection.id}
                guidePrice={selection.odds}
                index={i + 1}
                readOnly
              />
            );
          }

          const voidResult = selection.gradingResult === 'VOIDED' ? style['status--void'] : '';
          const voidRunner = selection.gradingResult === 'VOIDED' ? style['runnerName--void'] : '';
          let result = selection.gradingResult;
          if (selection.gradingResult === 'VOIDED') {
            result = 'Void';
          } else if (selection.gradingResult === 'ACTIVE') {
            result = '';
          }

          return (
            <div className={style.leg} key={selection.id}>
              <div className={style.leftContainer}>
                <div className={`${style.legNumber}`}>{i + 1}</div>
                <div
                  className={`${style.runnerName} ${
                    style[`runnerName--${selection.side}`]
                  } ${voidRunner}`}
                >
                  {selection.runnerName}
                </div>
              </div>
              <div className={style.rightContainer}>
                <div className={`${style.status} ${voidResult}`}>{result}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

ActiveMultiple.propTypes = {
  multiple: PropTypes.instanceOf(Record).isRequired,
  index: PropTypes.number.isRequired,
  showDetails: PropTypes.bool.isRequired,
  onShowDetails: PropTypes.func.isRequired,
};

export default ActiveMultiple;
